import _ from 'lodash'
import { getBaseQuery, getTagSearchQuery } from '../searchUtils'
import { getDataForCourseSearch, deleteCourseSearch, saveCourseSearch, getCourseSearches, getResults, getDepartments,
  getDivisions, getSubjects, getInstructors, deleteContent, deleteTopic, deleteStream, deleteCatalog, deleteJob, deleteClub,
  deleteEvent, getRecommendations, getRecommendationForEntity, getAllLibraryForUser, getLibraryPositionMapping, updateUserPreferences, execCopyMoveContent, getCourseFlags,
  callSearchForBulkOperation, addRecommendedToUsers, getAllEntityIdsWithRecommendation, getCompetencyLogic,getAIContents } from '../api'

export const loadSearchResults = ({ state, commit }, data) => {
  if (data.indexList.length === undefined || data.libraryList.length === undefined) {
    return {}
  }
  return getResults(data).then((res) => {
    // Process hits
    let hits = (res && res.hits && res.hits.hits) ? res.hits.hits : []
    let total = (res && res.hits && res.hits.total && res.hits.total.value) ? res.hits.total.value : 0
    let processedHits = []
    for (var i = 0; i < hits.length; i++) {
      let result = {
        index: hits[i]._index,
        resourceType: hits[i]._index,
        type: hits[i]._source.type,
        title: hits[i]._source.title,
        fileType: hits[i]._source.fileType,
        employer: hits[i]._source.employer,
        employerUuid: hits[i]._source.employerUuid,
        salaryRange: hits[i]._source.salaryRange,
        minSalary: hits[i]._source.minSalary,
        maxSalary: hits[i]._source.maxSalary,
        contactInfo: hits[i]._source.contactInfo,
        jobTypes: hits[i]._source.jobTypes,
        description: hits[i]._source.description,
        uuid: hits[i]._source.uuid,
        creationTime: hits[i]._source.creationTime,
        postedDate: hits[i]._source.postedDate,
        applyBy: hits[i]._source.applyBy,
        viewCount: hits[i]._source.viewCount,
        applicantCount: hits[i]._source.applicantCount,
        lastUpdatedTime: hits[i]._source.lastUpdatedTime,
        thumbnailURI: hits[i]._source.thumbnailURI,
        thumbnail: hits[i]._source.thumbnail,
        uri: hits[i]._source.uri,
        appliedTagMap: hits[i]._source.appliedTagMap,
        aggregatedAppliedTags: hits[i]._source.aggregatedAppliedTags,
        isAdded: false,
        originUuid: hits[i]._source.originUuid,
        mc: undefined,
        master: hits[i]._source.master,
        localPractice: hits[i]._source.localPractice,
        maxAttempt: hits[i]._source.maxAttempt,
        careerCompetenciesMap: hits[i]._source.careerCompetenciesMap,
        careerCompetenciesList: hits[i]._source.careerCompetenciesList,
        whiteListed: hits[i]._source.whiteListed,
        blackListed: hits[i]._source.blackListed,
        ownerId: hits[i]._source.ownerId,
        ownerName: hits[i]._source.ownerName
      }
      processedHits.push(result)
    }
    // Commit hits, facets and total
    commit('LOAD_TOTAL', total)
    commit('LOAD_RESULTS', processedHits)
    commit('LOAD_AGGREGATIONS', res.aggregations || {})
    return res
  })
}

export const updateResultIsAdded = ({ state, commit }, { index, status }) => {
  commit('UPDATE_RESULT_IS_ADDED', { index: index, status: status })
}

export const updateResultIsAddedByUUID = ({ state, commit }, uuid) => {
  var index = -1
  for (var i = 0; i < state.results.length; i++) {
    if (state.results[i].uuid === uuid) {
      index = i
    }
  }
  if (index !== -1) {
    commit('UPDATE_RESULT_IS_ADDED', { index: index, status: true })
  }
}

export const updateResultMCInfo = ({ state, commit }, data) => {
  commit('UPDATE_RESULT_MC_INFO', data)
}

export const updateResultMCInfoByUUID = ({ state, commit }, data) => {
  var index = -1
  for (var i = 0; i < state.results.length; i++) {
    if (state.results[i].uuid === data.uuid) {
      index = i
    }
  }
  if (index !== -1) {
    var mc = {
      index: index,
      mc: data.mc
    }
    commit('UPDATE_RESULT_MC_INFO', mc)
  }
}

export const updateFrom = ({ state, commit }, from) => {
  commit('LOAD_FROM', from)
}

export const updatePageNumber = ({ state, commit }, pageNumber) => {
  commit('LOAD_PAGE_NUMBER', pageNumber)
}

export const updateSize = ({ state, commit }, size) => {
  commit('LOAD_SIZE', size)
}

export const updateResetSelectedItems = ({ state, commit }, isResetSelectedItems) => {
  commit('LOAD_RESET_SELECTED_ITEMS', isResetSelectedItems)
}

export const updateSelectedIndexes = ({ state, commit }, selectedIndexes) => {
  commit('UPDATED_SELECTED_INDEXES', selectedIndexes)
}

var getGeoDistanceFilters = function (filterObj) {
  let geoFilters = []
  if (!filterObj || !filterObj.bool || !Array.isArray(filterObj.bool.must)) {
    return geoFilters
  }
  filterObj.bool.must.forEach((clause) => {
    if (clause && clause.geo_distance) {
      geoFilters.push(clause)
    }
  })
  return geoFilters
}

var addFilterToBoolQuery = function (boolQuery, clause) {
  if (!boolQuery) {
    return
  }
  if (!boolQuery.filter) {
    boolQuery.filter = [clause]
    return
  }
  if (Array.isArray(boolQuery.filter)) {
    boolQuery.filter.push(clause)
    return
  }
  boolQuery.filter = [boolQuery.filter, clause]
}

var addGeoDistanceFiltersToQuery = function (buildQuery, geoFilters) {
  if (!buildQuery || !geoFilters || geoFilters.length === 0) {
    return
  }
  geoFilters.forEach((geoFilter) => {
    if (buildQuery.constant_score && buildQuery.constant_score.filter && buildQuery.constant_score.filter.bool) {
      addFilterToBoolQuery(buildQuery.constant_score.filter.bool, geoFilter)
    } else if (buildQuery.bool) {
      addFilterToBoolQuery(buildQuery.bool, geoFilter)
    }
  })
}

export const constructSearchQuery = ({ state, commit }, {terms, matchAllInTags, matchAtLeastOneInTags, sort, source, from, size, indexList, libraryList, privateLibraryList, publicLibraryList, userId, pageNumber, aggs, filter, isResetSelectedItems, preserveSort}) => {
  if (pageNumber !== undefined) {
    commit('LOAD_PAGE_NUMBER', pageNumber)
  }

  if (terms !== undefined) {
    commit('LOAD_TERMS', terms)
  }

  if (matchAllInTags !== undefined) {
    commit('LOAD_MATCH_ALL', matchAllInTags)
  }

  if (matchAtLeastOneInTags !== undefined) {
    commit('LOAD_MATCH_AT_LEAST_ONE', matchAtLeastOneInTags)
  }

  if (source !== undefined) {
    commit('LOAD_SOURCE', source)
  }

  if (from !== undefined) {
    commit('LOAD_FROM', from)
  }

  if (size !== undefined) {
    commit('LOAD_SIZE', size)
  }

  if (indexList !== undefined) {
    commit('LOAD_INDEXLIST', indexList)
  }

  if (libraryList !== undefined) {
    commit('LOAD_LIBRARYLIST', libraryList)
  }

  if (privateLibraryList !== undefined) {
    commit('LOAD_PRIVATELIBRARYLIST', privateLibraryList)
  }

  if (publicLibraryList !== undefined) {
    commit('LOAD_PUBLICLIBRARYLIST', publicLibraryList)
  }

  if (userId === undefined) {
    userId = localStorage.getItem('userid')
  }

  if (aggs !== undefined) {
    commit('LOAD_AGGS', aggs)
  }

  if (filter !== undefined) {
    commit('LOAD_FILTER', filter)
  }

  if (isResetSelectedItems !== undefined) {
    commit('LOAD_RESET_SELECTED_ITEMS', isResetSelectedItems)
  }

  let buildQuery
  if (state.terms) {
    let queryString = {
      'query_string': {
        'fields': ['these_are_now_substituted_on_server_side'],
        'default_operator': 'OR',
        'allow_leading_wildcard': false,
        'query': 'TBA'
      }
    }
    queryString.query_string.query = state.terms
    buildQuery = getBaseQuery(state.privateLibraryList, state.publicLibraryList, userId, [])
    buildQuery.bool.must.push(queryString)
    if (!preserveSort) {
      sort = [{'_score': {'order': 'desc'}}]
    }
  } else {
    let matchAllInTags = state.matchAllInTags
    let matchAtLeastOneInTags = state.matchAtLeastOneInTags
    if (matchAllInTags.length > 0 || matchAtLeastOneInTags.length > 0) {
      buildQuery = getTagSearchQuery()
      if (matchAllInTags.length > 0) {
        let allTags = []
        let andQueryString = {
          'query_string': {
            'query': '',
            'tag_fields': [],
            'default_operator': 'AND'
          }
        }
        matchAllInTags.forEach((tag) => {
          let value = '"' + tag.tagValue + '"'
          allTags.push(value)
          let field = 'appliedTagMap.' + tag.category + '.name'
          andQueryString.query_string.tag_fields.push(field)
        })
        andQueryString.query_string.query = allTags.join(' ')
        buildQuery.bool.must.push(andQueryString)
      }
      if (matchAtLeastOneInTags.length > 0) {
        let eitherTags = []
        let orQueryString = {
          'query_string': {
            'query': '',
            'tag_fields': [],
            'default_operator': 'OR'
          }
        }
        matchAtLeastOneInTags.forEach((tag) => {
          let value = '"' + tag.tagValue + '"'
          eitherTags.push(value)
          let field = 'appliedTagMap.' + tag.category + '.name'
          orQueryString.query_string.tag_fields.push(field)
        })
        orQueryString.query_string.query = eitherTags.join(' ')
        buildQuery.bool.must.push(orQueryString)
      }
    } else {
      buildQuery = {
        'constant_score': {
          'filter': getBaseQuery(state.privateLibraryList, state.publicLibraryList, userId, []),
          'boost': 1.0
        }
      }
      let filterCopy = _.cloneDeep(state.filter)
      if (filterCopy && filterCopy.bool) {
        // let firstFilter = filterCopy.bool.must[0]
        filterCopy.bool.must = []
        // filterCopy.bool.must.push(firstFilter)
        buildQuery.constant_score.filter.bool['filter'] = [filterCopy]
      }
    }
    if (sort === undefined) {
      sort = [{lastUpdatedTime: {order: 'desc'}}]
    }
  }
  addGeoDistanceFiltersToQuery(buildQuery, getGeoDistanceFilters(state.filter))
  commit('LOAD_QUERY', buildQuery)
  commit('LOAD_SORT', sort)
  var payload = {
    sort: state.sort,
    _source: state._source,
    from: state.from,
    size: state.size,
    query: state.query,
    aggs: state.aggs,
    track_total_hits: true,
    post_filter: state.filter
  }

  var requestPayload = {
    'indexList': state.indexList,
    'libraryList': state.libraryList,
    'payload': payload
  }

  return loadSearchResults({ state, commit }, requestPayload)
}

export const deleteSelectedContent = ({ state, commit }, uuids) => {
  return deleteContent(uuids).then(res => {
    return res
  })
}

export const deleteSelectedTopic = ({ state, commit }, uuids) => {
  return deleteTopic(uuids).then(res => {
    return res
  })
}

export const deleteSelectedStreams = ({ state, commit }, uuids) => {
  return deleteStream(uuids).then(res => {
    return res
  })
}

export const deleteSelectedCatalogs = ({ state, commit }, uuids) => {
  return deleteCatalog(uuids).then(res => {
    return res
  })
}

export const deleteSelectedJobs = ({ state, commit }, uuids) => {
  return deleteJob(uuids).then(res => {
    return res
  })
}

export const deleteSelectedClubs = ({ state, commit }, uuids) => {
  return deleteClub(uuids).then(res => {
    return res
  })
}

export const deleteSelectedEvents = ({ state, commit }, uuids) => {
  return deleteEvent(uuids).then(res => {
    return res
  })
}

export const loadAllLibraryForUser = ({ state, commit }) => {
  return getAllLibraryForUser().then(libraries => {
    var folders = []
    if (libraries && libraries.length > 0) {
      libraries.forEach((library) => {
        const category = library.category
        if (category === 'LearningSpace' || category === 'Institute_Public' || category === 'User_Private') {
          folders.push(library)
        }
      })
    }
    return folders
  })
}

export const loadAllJobIdsWithRecommendation = ({ state, commit }) => {
  return getAllEntityIdsWithRecommendation('job')
}
export const loadRecommendations = ({ state, commit }, {userId, entityType}) => {
  return getRecommendations(userId, entityType)
}
export const loadRecommendationForEntity = ({ state, commit }, entityUuid) => {
  return getRecommendationForEntity(entityUuid)
}
export const recommendToUsers = ({ state, commit }, {entityId, uuids}) => {
  return addRecommendedToUsers(entityId, uuids).then(res => {
    return res
  })
}

export const loadLibraryPositionMapping = ({ state, commit }) => {
  if (_.isEmpty(state.libraryPositionMapping)) {
    return getLibraryPositionMapping().then(mapping => {
      commit('LOAD_LIBRARY_POSTION_MAPPING', mapping)
      return mapping
    })
  } else {
    commit('LOAD_LIBRARY_POSTION_MAPPING', state.libraryPositionMapping)
    return state.libraryPositionMapping
  }
}

export const updateFolderSelectionToUserPreferences = ({ state, commit }, {uuid, data}) => {
  return updateUserPreferences(uuid, data)
}

export const execCopyMoveSelectedContent = ({ state, commit }, {uuids, targetLibraryId, action}) => {
  return execCopyMoveContent(uuids, targetLibraryId, action)
}

export const loadDataForCourseSearch = ({ state, commit }, {currentYear, currentSemester}) => {
  if (!currentSemester || !currentSemester.length || currentSemester.length <= 0) {
    return
  }
  return getDataForCourseSearch(currentYear, currentSemester).then((data) => {
    let departmentMap = data.departments
    let divisionMap = data.divisions
    let subjectMap = data.subjects
    let instructorMap = data.instructors
    let majorMap = data.majors
    let unitMap = data.units
    let startTimeMap = data.startTimes
    let endTimeMap = data.endTimes
    let blockMap = data.blocks
    let levelMap = data.levels
    commit('LOAD_DEPARTMENT_MAP', _.invert(departmentMap))
    commit('LOAD_DIVISION_MAP', _.invert(divisionMap))
    commit('LOAD_SUBJECT_MAP', _.invert(subjectMap))
    commit('LOAD_INSTRUCTOR_MAP', _.invert(instructorMap))
    commit('LOAD_MAJOR_MAP', _.invert(majorMap))
    commit('LOAD_UNIT_MAP', _.invert(unitMap))
    commit('LOAD_START_TIME_MAP', _.invert(startTimeMap))
    commit('LOAD_END_TIME_MAP', _.invert(endTimeMap))
    commit('LOAD_BLOCK_MAP', _.invert(blockMap))
    commit('LOAD_LEVEL_MAP', _.invert(levelMap))
    return data
  })
}

export const loadDepartments = ({ state, commit }, {libraryUuid, semesterCode}) => {
  if (!semesterCode || !semesterCode.length || semesterCode.length <= 0) {
    return
  }
  return getDepartments(libraryUuid, semesterCode).then((data) => {
    let departmentMap = {}
    for (const key of Object.keys(data)) {
      let value = data[key]
      departmentMap[value] = key
    }
    commit('LOAD_DEPARTMENT_MAP', departmentMap)
    return departmentMap
  })
}

export const loadAIContents = ({ state, commit }, courseId) => {

  return getAIContents(courseId).then((data) => {
    return data
  })
}

export const loadCompetencyLogic = ({ state, commit }, {courseId, type}) => {
    return getCompetencyLogic(courseId, type).then((data) => {
      return data
  })
}
export const loadDivisions = ({ state, commit }, {libraryUuid, semesterCode}) => {
  if (!semesterCode || !semesterCode.length || semesterCode.length <= 0) {
    return
  }
  return getDivisions(libraryUuid, semesterCode).then((data) => {
    let divisionMap = {}
    for (const key of Object.keys(data)) {
      let value = data[key]
      divisionMap[value] = key
    }
    commit('LOAD_DIVISION_MAP', divisionMap)
    return divisionMap
  })
}

export const loadSubjects = ({ state, commit }, {libraryUuid, semesterCode}) => {
  if (!semesterCode || !semesterCode.length || semesterCode.length <= 0) {
    return
  }
  return getSubjects(libraryUuid, semesterCode).then((data) => {
    let subjectMap = {}
    for (const key of Object.keys(data)) {
      let value = data[key]
      subjectMap[value] = key
    }
    commit('LOAD_SUBJECT_MAP', subjectMap)
    return data
  })
}

export const loadInstructors = ({ state, commit }, {libraryUuid, semesterCode}) => {
  if (!semesterCode || !semesterCode.length || semesterCode.length <= 0) {
    return
  }
  return getInstructors(libraryUuid, semesterCode).then((data) => {
    let instructorMap = {}
    for (const key of Object.keys(data)) {
      let value = data[key]
      instructorMap[value] = key
    }
    commit('LOAD_INSTRUCTOR_MAP', instructorMap)
    return data
  })
}

export const loadCourseSearches = ({ state, commit }, uuid) => {
  return getCourseSearches(uuid).then((response) => {
    if (!response || !response.length || response.length <= 0) {
      commit('LOAD_COURSE_SEARCHES', [])
    } else if (response.length > 1) {
      commit('LOAD_COURSE_SEARCHES', response)
    } else {
      let singleCourseSearch = response[0]
      commit('LOAD_COURSE_SEARCHES', [singleCourseSearch])
    }
    return response
  })
}

export const loadCourseFlags = ({ state, commit }, {libraryUuid, semesterCode}) => {
  if (!semesterCode || !semesterCode.length || semesterCode.length <= 0) {
    return
  }
  return getCourseFlags(libraryUuid, semesterCode).then((response) => {
    commit('LOAD_COURSE_FLAGS', response)
    return response
  })
}

export const storeCourseSearch = ({ state, commit }, {courseSearchObj, libraryId}) => {
  return saveCourseSearch(courseSearchObj, libraryId).then((response) => {
    courseSearchObj.uuid = response.uuid
    // NOTE: Editing/Saving course search is handled by making another DB call to reload the entries.
    //       A race condition was discovered in development when using the mutation below
    // commit('LOAD_COURSE_SEARCHES', courseSearchObj)
    return response
  })
}

export const removeCourseSearch = ({ state, commit }, {courseSearch, libraryId}) => {
  return deleteCourseSearch(courseSearch.uuid, libraryId).then((response) => {
    if (state.courseSearches.includes(courseSearch)) {
      commit('DELETE_COURSE_SEARCH', courseSearch)
    }
    return response
  })
}

export const showCourseSectionDropDown = ({ state, commit }, lastUpdatedTime) => {
  commit('UPDATE_LAST_UPDATED_TIME', lastUpdatedTime)
  commit('SHOW_DROP_DOWN', true)
}

export const storeSelectedFactes = ({ state, commit }, data) => {
  commit('UPDATE_SELECTED_FACETS', data)
}

export const resetSelectedFactes = ({ state, commit }, data) => {
  let facets = [
    {key: 'indexesSelected', value: []},
    {key: 'courseTypeSelected', value: []},
    {key: 'assetTypeSelected', value: []},
    {key: 'jobTypeSelected', value: []},
    {key: 'personTypeSelected', value: []},
    {key: 'streamTypeSelected', value: []},
    {key: 'divisionTypeSelected', value: []},
    {key: 'departmentTypeSelected', value: []},
    {key: 'creditTypeSelected', value: []},
    {key: 'subjectTypeSelected', value: []},
    {key: 'levelTypeSelected', value: []}
  ]
  facets.forEach(data => {
    commit('UPDATE_SELECTED_FACETS', data)
  })
}

export const loadSearchForBulkOperation = ({ state, commit }, data) => {
  if (data.indexList.length === undefined) {
    return {}
  }
  return callSearchForBulkOperation(data).then(resp => {
    return resp
  })
}

export const constructSearchQueryForBulkOperation = ({ state, commit }, {from, size, userId, operation, targetLibraryId}) => {
  let buildQuery
  if (state.terms) {
    let queryString = {
      'query_string': {
        'fields': ['these_are_now_substituted_on_server_side'],
        'default_operator': 'OR',
        'allow_leading_wildcard': false,
        'query': 'TBA'
      }
    }
    queryString.query_string.query = state.terms
    buildQuery = getBaseQuery(state.privateLibraryList, state.publicLibraryList, userId, [])
    buildQuery.bool.must.push(queryString)
    sort = [{'_score': {'order': 'desc'}}]
  } else {
    let matchAllInTags = state.matchAllInTags
    let matchAtLeastOneInTags = state.matchAtLeastOneInTags
    if (matchAllInTags.length > 0 || matchAtLeastOneInTags.length > 0) {
      buildQuery = getTagSearchQuery()
      if (matchAllInTags.length > 0) {
        let allTags = []
        let andQueryString = {
          'query_string': {
            'query': '',
            'tag_fields': [],
            'default_operator': 'AND'
          }
        }
        matchAllInTags.forEach((tag) => {
          let value = '"' + tag.tagValue + '"'
          allTags.push(value)
          let field = 'appliedTagMap.' + tag.category + '.name'
          andQueryString.query_string.tag_fields.push(field)
        })
        andQueryString.query_string.query = allTags.join(' ')
        buildQuery.bool.must.push(andQueryString)
      }
      if (matchAtLeastOneInTags.length > 0) {
        let eitherTags = []
        let orQueryString = {
          'query_string': {
            'query': '',
            'tag_fields': [],
            'default_operator': 'OR'
          }
        }
        matchAtLeastOneInTags.forEach((tag) => {
          let value = '"' + tag.tagValue + '"'
          eitherTags.push(value)
          let field = 'appliedTagMap.' + tag.category + '.name'
          orQueryString.query_string.tag_fields.push(field)
        })
        orQueryString.query_string.query = eitherTags.join(' ')
        buildQuery.bool.must.push(orQueryString)
      }
    } else {
      buildQuery = {
        'constant_score': {
          'filter': getBaseQuery(state.privateLibraryList, state.publicLibraryList, userId, []),
          'boost': 1.0
        }
      }
      let filterCopy = _.cloneDeep(state.filter)
      if (filterCopy && filterCopy.bool) {
        // let firstFilter = filterCopy.bool.must[0]
        filterCopy.bool.must = []
        // filterCopy.bool.must.push(firstFilter)
        buildQuery.constant_score.filter.bool['filter'] = [filterCopy]
      }
    }
  }
  var payload = {
    from: from,
    size: size,
    _source: false,
    query: state.query,
    track_total_hits: true,
    post_filter: state.filter
  }

  let entities = (operation === 'DELETE') ? state.indexList.replace(new RegExp('deliverycontext,?'), '') : 'learningcontent'
  var requestPayload = {
    'indexList': entities,
    'payload': payload,
    'operation': operation,
    'targetLibraryId': targetLibraryId
  }

  return loadSearchForBulkOperation({ state, commit }, requestPayload)
}



// WEBPACK FOOTER //
// ./src/app/search/vuex/actions.js